import { render } from "./Auctions.vue?vue&type=template&id=49ecb5f6"
import script from "./Auctions.vue?vue&type=script&lang=js"
export * from "./Auctions.vue?vue&type=script&lang=js"
script.render = render

export default script